import { render } from "./DynamicTopMatter.vue?vue&type=template&id=6353b456&scoped=true&ts=true"
import script from "./DynamicTopMatter.vue?vue&type=script&lang=ts"
export * from "./DynamicTopMatter.vue?vue&type=script&lang=ts"

import "./DynamicTopMatter.vue?vue&type=style&index=0&id=6353b456&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6353b456"]])

export default __exports__